angular
    .module('vm')
    .component('signUpMay19Phone', {
        templateUrl: 'sign-up-may-19-phone.component.html',
        bindings: {
            'progress': '=',
        },
        controllerAs: 'vm',
        controller: function (CONFIG, SignUpMay19Service, $api, GoogleAnalyticsService, Notifications, DomainSettings) {
            const vm = this;

            vm.CONFIG = CONFIG;
            vm.formData = {
                phoneNumber: '',
                numberWithoutPrefix: '',
                countryCode: ''
            };

            vm.stepType = 'phone';
            vm.selectedCountry = null;
            vm.countries = [];

            vm.submitForm = submitForm;
            vm.$onInit = activate;
            vm.goBack = goBack;

            const excludeCountries = ['MP', 'SS', 'YT', 'AX', 'PM', 'SH', 'SJ', 'UM', 'GF', 'WF', 'BQ', 'TK'];

            ////////////

            function activate() {
                vm.formData = SignUpMay19Service.getStepAnswer(vm.stepType);

                getCountries()
                    .then((countries) => {
                        vm.countries = countries;

                        if (vm.formData) {
                            vm.selectedCountry = vm.countries.find((country) => {
                                return country.code === vm.formData.countryCode;
                            });
                        } else {
                            DomainSettings.get().then((domainSettings) => {
                                vm.selectedCountry = vm.countries.find((country) => {
                                    return country.code === domainSettings.ipCountryCode;
                                });

                                if (!vm.selectedCountry) {
                                    vm.selectedCountry = vm.countries[0];
                                }
                            });
                        }
                    })
                ;
            }

            function submitForm() {
                vm.formData.countryCode = vm.selectedCountry.code;
                vm.formData.phoneNumber = vm.selectedCountry.phonePrefix + vm.formData.numberWithoutPrefix; 

                $api.post('phone-verification/send-code', vm.formData)
                    .then(() => {
                        GoogleAnalyticsService.fireEvent(
                            'SignUp May 19', 
                            'phone'
                        );
                        
                        SignUpMay19Service.saveStepAnswer(vm.stepType, vm.formData);
                        SignUpMay19Service.goToNextStep(vm.stepType);
                    })
                    .catch((response) => {
                        Notifications.add({
                            text: response.data.error || response.data.message,
                            type: 'error'
                        });
                    })
                ;
            }

            function goBack() {
                history.back();
            }

            function getCountries() {
                return $api.get('geo/country-list')
                    .then((response) => {
                        return response.data
                            .filter((country) => {
                                return country.phonePrefix.length > 1;
                            })
                            .filter((country) => {
                                return excludeCountries.indexOf(country.code) === -1;
                            })
                        ;
                    })
                ;
            }
        }
    })
;